import * as React from 'react'
import {faTimes, faTimesCircle} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export class Modal extends React.Component<{isOpen:boolean, /*marginTop?:string,*/title?:string, 
subtitle?:string, /*height?:string,width?:string, left?:string, border?: string,*/ cancel?:() => void,
/*right?:string, top?:string, bottom?:string,*/ modalTop_1?:boolean, /*background?:string, marginLeft?:string*/}, {}> {

    modalStyle = { 
        left:'auto', 
        right:'30px', 
        top:'110px',
        bottom:'auto',
        height:'auto',
        marginTop:'0%',
        width:'auto', 
        position:'absolute' as 'absolute',
        background:'#fff',
        zIndex:9999, 
        borderRadius:'0px',
        padding: '20px 20px 0px 20px',
        border: '2px solid #fd2219',
        // boxSizing: 'border-box'        
    }

    mainDivStyle= {
        height:'100%',
        width:'100%',
        backgroundColor:'transparent',
        zIndex:9998,
        position:'absolute' as 'absolute'
    } 

    render() {

    if (this.props.modalTop_1) {
        this.modalStyle.zIndex = 9997
        this.mainDivStyle.zIndex = 9996
    }

    if(this.props.isOpen == false) {
        return null
    } else {

        return(
            <div style = {this.mainDivStyle}>
                <div style = {this.modalStyle}>
                    {this.props.cancel ? 
                    <button 
                            style = {{
                                float:'right', 
                                background:'transparent',
                                border:'0px',
                                display:'block',
                                marginTop:'-20px',
                                marginRight:'-20px'}}
                            onClick = {this.props.cancel}
                    >
                        <FontAwesomeIcon icon = {faTimes}/>
                    </button>                    
                    : void 0}
                    {this.props.title && this.props.title.length > 0 ? 
                    <h3 style = {{marginLeft:'7px', width: '100%'}}>{this.props.title}{this.props.subtitle ?
                        <small>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{this.props.subtitle}</small>
                    : void 0}
                    </h3> 
                    : void 0}
                    {this.props.children ? this.props.children : null}
                    <div className = "clearfix"/>
                </div>
            </div>
        )}
    }
}

export class ModalCalendar extends React.Component<{isOpen:boolean, /*marginTop?:string,*/title?:string, 
subtitle?:string, /*height?:string,width?:string, left?:string, border?: string,*/ cancel?:() => void,
/*right?:string, top?:string, bottom?:string,*/ modalTop_1?:boolean, /*background?:string, marginLeft?:string*/
height: string, width: string}, {}> {
    
        modalStyle = { 
            left:'0px', 
            right:'0px',
            width: this.props.width, 
            height: this.props.height,
            top:'0px',
            margin: '0 auto',
            position:'absolute' as 'absolute',
            background:'transparent',
            zIndex:9999,
            padding:'20px',
            // border: '2px solid #fd2219',
            // borderRadius: '10px'
            // boxSizing: 'border-box'
        }
    
        mainDivStyle= {
            height:'100%',
            width:'100%',
            // background: 'rgba (0,0,0,0.9)',
            zIndex:9998,
            position:'absolute' as 'absolute'
        } 
    
        render() {
    
        if (this.props.modalTop_1) {
            this.modalStyle.zIndex = 9997
            this.mainDivStyle.zIndex = 9996
        }
    
        if(this.props.isOpen == false) {
            return null
        } else {
    
            return(
                <div style = {this.mainDivStyle}>
                    <div style = {this.modalStyle}>
                        {this.props.cancel ? 
                        <button onClick = {this.props.cancel} className = "scandibet-cancel-button">
                            <FontAwesomeIcon className = "scandibet-cancel" icon = {faTimes}/>
                        </button>                    
                        : void 0}
                        {this.props.title && this.props.title.length > 0 ? 
                        <h3 style = {{marginLeft:'7px', width: '100%'}}>{this.props.title}{this.props.subtitle ?
                            <small>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{this.props.subtitle}</small>
                        : void 0}
                        </h3> 
                        : void 0}
                        {this.props.children ? this.props.children : null}
                        <div className = "clearfix"/>
                    </div>
                </div>
            )}
        }
    }
    
export class ModalConfirmation extends React.Component<{isOpen:boolean,title?:string,subtitle?:string,cancel?:()=>void,
                                                        modalTop_1?:boolean,height: string,width:string,r?:string},{}> {
            modalStyle = { 
/*
                left:'0px', 
                right:'0px',
                top:'0px',
                bottom:'0px',
                margin: 'auto',

*/
                borderRadius: this.props.r,
                width: this.props.width, 
                height: this.props.height,
                position:'absolute' as 'absolute',
                background:'#01498c',
                zIndex:9999,
                padding:'1px',
            }
        
            mainDivStyle= {
                height:'100%',
                width:'100%',
                backgroundColor: 'rgba(0, 0, 0, 0.9)',
                // backgroundColor: '#000',
                zIndex:9998,
                position:'absolute' as 'absolute'
            } 
        
            render() {
        
            if (this.props.modalTop_1) {
                this.modalStyle.zIndex = 9997
                this.mainDivStyle.zIndex = 9996
            }
        
            if(this.props.isOpen == false) {
                return null
            } else {
        
                return(
                    <div style = {this.mainDivStyle}>
                        <div className = "Confirmation" style = {this.modalStyle}>
                            <div className = "confirmation">
                            {this.props.cancel ? 
                            <button onClick = {this.props.cancel} className = "confirmation-cancel">
                                <FontAwesomeIcon icon = {faTimesCircle}/>
                            </button>                    
                            : void 0}
                            {/*<span className = "confirmation-title">>{this.props.title}</span>*/}
                            {this.props.children ? this.props.children : null}
                            &nbsp;
                            </div>
                        </div>
                    </div>
                )}
            }
        }


// WEBPACK FOOTER //
// ./src/Views/Reusables/Modal.tsx